import sbpServices from "../../../services/sbpServices";
import patientinfocreater from "./patientInfoActionCreaters";

export const _patientInformation =
  (patinetinfofields, caseinfofields) =>
  /* istanbul ignore next */ async (dispatch) => {
    try {
      //console.log(patinetinfofields,"ss")
      /* istanbul ignore next */
      dispatch(patientinfocreater.patientInfoLoadStart());
      /* istanbul ignore next */
      const res = await sbpServices
      ._submitpatientInfo(patinetinfofields, caseinfofields)
        .then((result) => {
          return result;
        });
      /* istanbul ignore next */
      if (res.status === 200) {
        /* istanbul ignore next */
        dispatch(patientinfocreater.patientInfoLoadSuccess(res.data));
      }
      if (res.status === 204) {       
        dispatch(patientinfocreater.patientInfoLoadErrors(res));
      }
    } catch (err) {
      /* istanbul ignore next */
      dispatch(patientinfocreater.patientInfoLoadErrors(err.response));
    }
  };
